export const getCanContinue = (state) => state.canContinue;